import React from "react";
import { useTranslation } from "react-i18next";

const STATUS_CONFIG = {
    operational: {
        color: "bg-emerald-500",
        ringColor: "ring-emerald-500/20",
        textColor: "text-emerald-700",
        bgColor: "bg-emerald-50",
    },
    degraded: {
        color: "bg-amber-500",
        ringColor: "ring-amber-500/20",
        textColor: "text-amber-700",
        bgColor: "bg-amber-50",
    },
    outage: {
        color: "bg-red-500",
        ringColor: "ring-red-500/20",
        textColor: "text-red-700",
        bgColor: "bg-red-50",
    },
};

function ServiceCard({ service }) {
    const { t } = useTranslation();
    const config = STATUS_CONFIG[service.status] || STATUS_CONFIG.operational;

    return (
        <div className="flex items-center justify-between p-4 rounded-xl border border-gray-100 bg-white hover:border-gray-200 transition-colors duration-150">
            <div className="flex items-center gap-3">
                <div className={`w-2.5 h-2.5 rounded-full ${config.color} ring-4 ${config.ringColor}`} />
                <span className="font-medium text-gray-900 text-sm">{service.name}</span>
            </div>
            <div className="flex items-center gap-4">
                {service.latencyP50 != null && (
                    <span className="text-xs text-gray-400">
                        p50: {service.latencyP50}ms
                    </span>
                )}
                {service.latencyP99 != null && (
                    <span className="text-xs text-gray-400">
                        p99: {service.latencyP99}ms
                    </span>
                )}
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${config.bgColor} ${config.textColor}`}>
                    {t(`statusPage.status.${service.status}`)}
                </span>
            </div>
        </div>
    );
}

export default ServiceCard;
